const PDFJS_VERSION = '3.11.174';
const PDFJS_SCRIPT_URL = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDFJS_VERSION}/pdf.min.js`;
const PDFJS_WORKER_URL = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDFJS_VERSION}/pdf.worker.min.js`;

declare global {
	interface Window {
		pdfjsLib: any;
	}
}

export const loadPdfJs = async (): Promise<any> => {
	if (window.pdfjsLib) {
		window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER_URL;
		return window.pdfjsLib;
	}

	return new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = PDFJS_SCRIPT_URL;
		script.onload = () => {
			window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER_URL;
			resolve(window.pdfjsLib);
		};
		script.onerror = reject;
		document.head.appendChild(script);
	});
};
